import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "disabled", "hideLabel", "id", "labelPosition", "labelText", "name", "onChange", "value"];
import React from 'react';
import classNames from 'classnames';
import { usePrefix } from '../../../internal/usePrefix';
import { useId } from '../../../internal/useId';
import { Text } from '../../Text';
var RadioButton = /*#__PURE__*/React.forwardRef(function RadioButton(_ref, ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      hideLabel = _ref.hideLabel,
      id = _ref.id,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? 'right' : _ref$labelPosition,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? '' : _ref$labelText,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var prefix = usePrefix();
  var uid = useId('radio-button');
  var uniqueId = id || uid;

  function handleOnChange(event) {
    onChange(value, name, event);
  }

  var innerLabelClasses = classNames(_defineProperty({}, "".concat(prefix, "--visually-hidden"), hideLabel));
  var wrapperClasses = classNames(className, "".concat(prefix, "--radio-button-wrapper"), _defineProperty({}, "".concat(prefix, "--radio-button-wrapper--label-").concat(labelPosition), labelPosition !== 'right'));
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    type: "radio",
    className: "".concat(prefix, "--radio-button"),
    onChange: handleOnChange,
    id: uniqueId,
    ref: ref,
    disabled: disabled
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: uniqueId,
    className: "".concat(prefix, "--radio-button__label")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "--radio-button__appearance")
  }), labelText && /*#__PURE__*/React.createElement(Text, {
    className: innerLabelClasses
  }, labelText)));
});
export default RadioButton;